// 9fbef606107a605d69c0edbcd8029e5d
/**
 * These are temporary changes for a dummy login page
 */

const LOGINPAGE_CONSTANTS = {
  LOGIN: 'LOGIN',
  EMAIL_SUBMIT: 'EMAIL_SUBMIT',
  SET_EXISTING_USER_RESPONSE: 'SET_EXISTING_USER_RESPONSE',
  SET_LOGIN_INFO: 'SET_LOGIN_INFO',
  GET_USER_INFO: 'GET_USER_INFO',
  RESET_LOGIN_INFO: 'RESET_LOGIN_INFO',
  LOGIN_MODAL_MOUNTED_STATE: 'LOGIN_MODAL_MOUNTED_STATE',
  CHECKOUT_MODAL_MOUNTED_STATE: 'CHECKOUT_MODAL_MOUNTED_STATE',
  PAGE_TYPE: {
    LOGIN: 'login',
    FORGOT_PASSWORD: 'forgotPassword',
    RESET_PASSWORD: 'resetPassword',
  },
  SET_LOGIN_LOADING_STATE: 'SET_LOGIN_LOADING_STATE',
  SET_PLCC_LOGIN_LOADING_STATE: 'SET_PLCC_LOGIN_LOADING_STATE',
  LOGIN_SFCC: 'LOGIN_SFCC',
  SET_EMAIL_RETRY_COUNT: 'SET_EMAIL_RETRY_COUNT',
  MASKED_PHONE_NUMBER: 'MASKED_PHONE_NUMBER',
  SHOW_PHONE_LOGIN_OPTION: 'SHOW_PHONE_LOGIN_OPTION',
  GENERATE_LOGIN_OTP: 'GENERATE_LOGIN_OTP',
  SHOW_OTP_INPUT_SCREEN: 'SHOW_OTP_INPUT_SCREEN',
  OTP_TOKEN: 'OTP_TOKEN',
  USER_NOT_EXIST: 'USER_NOT_EXIST',
  LOGIN_SELECTION_OPTION: 'LOGIN_SELECTION_OPTION',
  IS_OTP_LIMIT: 'IS_OTP_LIMIT',
  SHOW_EMAIL_FORM_SCREEN: 'SHOW_EMAIL_FORM_SCREEN',
  IS_LOCKED: 'IS_LOCKED',
  SET_COUNTRY_CODE: 'SET_COUNTRY_CODE',
};

export default LOGINPAGE_CONSTANTS;
